import { GridStackNode } from 'gridstack';

export type CipoGridstackPositions = Pick<GridStackNode, 'x' | 'y' | 'w' | 'h'> & { id: number };
export type GridstackHeaderItem = CipoGridstackPositions & { label: string };
